export const ClassTypesEnum = {
    'Presencial': 1,
    'Virtual': 2,
    'IN_COMPANY': 3,
}


// WEBPACK FOOTER //
// ./src/enums/ClassTypesEnum.js